import {
  Box,
  Container,
  Heading,
  VStack,
  Text,
  Button,
  Flex,
  useDisclosure,
  Collapse,
} from "@chakra-ui/react";
import {
  ChevronLeftIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@chakra-ui/icons";
import { useParams, useNavigate } from "react-router-dom";
import { useConditionalBackground } from "@/contexts/useConditionalBackground ";
import Logo from "@/components/Logo";

const FAQItem = ({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box borderBottom="1px" borderColor="gray.200">
      <Button
        onClick={onToggle}
        variant="ghost"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        py={4}
        textAlign="left"
      >
        <Text fontSize={["sm", "md", "lg"]} fontWeight="medium" mr={2}>
          {question}
        </Text>
        <Box flexShrink={0}>
          {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Box>
      </Button>
      <Collapse in={isOpen} animateOpacity>
        <Box py={4} pl={4}>
          <Text color="gray.600" fontSize={["xs", "sm", "md"]}>
            <Text as="span" fontWeight="bold">
              R:{" "}
            </Text>
            {answer}
          </Text>
        </Box>
      </Collapse>
    </Box>
  );
};

export default function FAQ() {
  const { shorthash } = useParams<{ shorthash: string }>();
  const navigate = useNavigate();
  const backgroundStyle = useConditionalBackground();

  const handleBack = async () => {
    navigate(`/${shorthash}/introducao`);
  };

  const faqData = [
    {
      question: "Quanto vocês cobram de taxa de juros?",
      answer: "1,79% ao mês",
    },
    {
      question: "Quanto tempo receberei meu pagamento?",
      answer: "Em até 1 dia útil",
    },
    {
      question: "Até quantos anos posso antecipar?",
      answer: "Até 12 anos",
    },
  ];

  return (
    <Box minHeight="100vh" {...backgroundStyle}>
      <Container maxW="container.xl" py={8} px={[2, 4, 8]}>
        <Button
          onClick={handleBack}
          aria-label="Voltar"
          variant="link"
          color="white"
          _hover={{ color: "gray.200" }}
        >
          <ChevronLeftIcon boxSize={6} />
        </Button>
        <Flex justifyContent="center" mt={8} mb={12}>
          <Logo variant="primary" alt="Logo" boxSize="200px" objectFit="contain" />
        </Flex>
        <Heading
          as="h1"
          size={["xl", "2xl"]}
          textAlign="center"
          mb={12}
          color="white"
        >
          Perguntas Frequentes
        </Heading>
        <Box
          maxW="2xl"
          mx="auto"
          bg="white"
          rounded="lg"
          shadow="lg"
          p={[4, 6]}
        >
          <VStack spacing={4} align="stretch">
            {faqData.map((item, index) => (
              <FAQItem
                key={index}
                question={item.question}
                answer={item.answer}
              />
            ))}
          </VStack>
        </Box>
      </Container>
    </Box>
  );
}
